import { onMounted, onUnmounted, ref, getCurrentInstance } from 'vue'
import log from '@/utils/useLogger'
export function useAudioController() {
  const speechSynthesisElements = ref(new Map<string, SpeechSynthesisUtterance>())
  const availableVoices = ref<SpeechSynthesisVoice[]>([])
  const currentVoice = ref<SpeechSynthesisVoice | null>(null)

  // loadvoices
  const loadVoices = () => {
    availableVoices.value = window.speechSynthesis.getVoices()

    const preferredVoice = availableVoices.value.find(
      (v) =>
        v.name === 'Google UK English Female' ||
        v.name.includes('Female') ||
        v.lang.startsWith('en-'),
    )
    currentVoice.value = preferredVoice || availableVoices.value[0]
  }

  const instance = getCurrentInstance()
  if (instance) {
    onMounted(() => {
      loadVoices()

      if (window.speechSynthesis) {
        window.speechSynthesis.addEventListener('voiceschanged', loadVoices)
      }
    })
  } else {
    // Initialize immediately when not in component context
    loadVoices()
    if (window.speechSynthesis) {
      window.speechSynthesis.addEventListener('voiceschanged', loadVoices)
    }
  }

  const playAudio = (audioId: string) => {
    try {
      if (!speechSynthesisElements.value.has(audioId)) {
        const utterance = new SpeechSynthesisUtterance(audioId)

        if (currentVoice.value) utterance.voice = currentVoice.value
        speechSynthesisElements.value.set(audioId, utterance)
      }

      const utterance = speechSynthesisElements.value.get(audioId)

      if (utterance) {
        window.speechSynthesis.speak(utterance)
      }
    } catch (error) {
      log.error(`Error with speech synthesis for ${audioId}:`, error)
    }
  }
  const stopAudio = (audioId: string) => {
    try {
      window.speechSynthesis.cancel()
    } catch (error) {
      log.error(`Error stopping audio ${audioId}:`, error)
    }
  }
  if (instance) {
    onUnmounted(() => {
      cleanup()
    })
  }
  const cleanup = () => {
    speechSynthesisElements.value.clear()
    window.speechSynthesis.removeEventListener('voiceschanged', loadVoices)
  }
  return {
    playAudio,
    stopAudio,
    cleanup,
  }
}
